export const countryByPltyp = {
  "01": "DE",
  CH: "CH",
  DE: "DE",
  ES: "ES",
  IT: "IT",
  US: "US",
};
